// Ce fichier peut être inclus dans votre projet React pour enregistrer le service worker
// Placez-le dans votre dossier src/ et importez-le dans votre index.js

// Fonction pour enregistrer le service worker
const registerServiceWorker = () => {
  if ("serviceWorker" in navigator) {
    window.addEventListener("load", () => {
      navigator.serviceWorker
        .register("/service-worker.js")
        .then((registration) => {
          console.log(
            "Service Worker enregistré avec succès:",
            registration.scope
          );

          // Gestionnaire de mise à jour du service worker
          registration.onupdatefound = () => {
            const installingWorker = registration.installing;
            if (installingWorker == null) {
              return;
            }

            installingWorker.onstatechange = () => {
              if (installingWorker.state === "installed") {
                if (navigator.serviceWorker.controller) {
                  // Une nouvelle version du service worker est disponible
                  console.log(
                    "Une nouvelle version est disponible et sera utilisée au prochain chargement de la page."
                  );

                  // Afficher une notification à l'utilisateur
                  if (
                    window.confirm(
                      "Une nouvelle version de BoxPlaisir.be est disponible. Voulez-vous la charger maintenant?"
                    )
                  ) {
                    window.location.reload();
                  }
                } else {
                  // Premier service worker pour cette page
                  console.log(
                    "Le contenu est maintenant disponible hors ligne."
                  );
                }
              }
            };
          };
        })
        .catch((error) => {
          console.error(
            "Erreur lors de l'enregistrement du service worker:",
            error
          );
        });

      // Gestion des événements online/offline
      window.addEventListener("online", () => {
        console.log("Application en ligne");
        document.dispatchEvent(new CustomEvent("app_online"));
      });

      window.addEventListener("offline", () => {
        console.log("Application hors ligne");
        document.dispatchEvent(new CustomEvent("app_offline"));
      });
    });
  }
};

// Fonction pour vérifier si l'application peut être installée
const checkInstallability = (setCanInstall) => {
  window.addEventListener("beforeinstallprompt", (e) => {
    // Empêcher Chrome 67+ d'afficher automatiquement la notification d'installation
    e.preventDefault();

    // Stocker l'événement pour pouvoir le déclencher plus tard
    window.deferredPrompt = e;

    // Mettre à jour l'état pour indiquer que l'app peut être installée
    if (setCanInstall && typeof setCanInstall === "function") {
      setCanInstall(true);
    }

    console.log("L'application peut être installée");
  });
};

// Fonction pour installer l'application PWA
const installApp = async () => {
  if (!window.deferredPrompt) {
    console.log("Pas d'événement d'installation disponible");
    return false;
  }

  // Afficher la notification d'installation
  const promptEvent = window.deferredPrompt;
  promptEvent.prompt();

  // Attendre que l'utilisateur réponde à la notification
  const choiceResult = await promptEvent.userChoice;

  // Vérifier si l'utilisateur a accepté l'installation
  const accepted = choiceResult.outcome === "accepted";

  // Nettoyer l'événement d'installation différé
  window.deferredPrompt = null;

  return accepted;
};

// Exporter les fonctions
export { registerServiceWorker, checkInstallability, installApp };

// Si vous importez ce fichier directement dans index.js, vous pouvez
// exécuter directement la fonction d'enregistrement
registerServiceWorker();
